import Vue from "vue";

import MainLayout from "./router/layouts/MainLayout";

Vue.component("MainLayout", MainLayout);
